import { Injectable } from '@angular/core';
import { AppService } from './app.service'; // Import the AppService (update with the correct path)
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadMediaService {
  searchText: string = '';
  page_first_result: number = 0;
  resource_type_id: any = 1;
  result_per_page: number = 30;
  public counts = [50, 100, 150, 200, 250, 300];
  public count: any = this.counts[0];
  rowCount: any = 0;
  images: any[] = [];
  visible_data: boolean = false;
  visibleloader: boolean = false;
  constructor(private appService: AppService) {
  }

  loadMedias() {
    this.searchText = this.searchText ? this.searchText : '';
    this.appService.getAllImages(this.resource_type_id, this.page_first_result, this.result_per_page, this.searchText).subscribe(data => {
      this.images = data;
      if (this.images.length == 0) {
        this.visible_data = true;
        this.visibleloader = true;
      }
      else {
        this.visible_data = false;
        this.visibleloader = false;
        this.rowCount = this.images[0].row_count;
      }
    }, error => {
      //  Admin portal should logout when token expired
      if (error.error.status) {
        this.appService.signOut();
      }
    });
  }

}